import React from 'react';
import { Info, TriangleAlert } from 'lucide-react';
import ExplainedIcon from 'src/shared/components/explained-icon/ExplainedIcon';

/** Why a control cannot be changed, and how loudly to say so. */
export type LockReason = { message: string; tone: 'warning' | 'info' };

type LockReasonIconProps = {
    reason: LockReason;
    testId?: string;
};

/**
 * The reason a control is locked, as an icon that explains itself on hover.
 *
 * As a tooltip the reason is there when looked for and silent otherwise, so it
 * does not compete with the text beside the control.
 */
const LockReasonIcon = ({ reason, testId }: LockReasonIconProps) =>
    reason.tone === 'warning' ? (
        <ExplainedIcon message={reason.message} className='text-amber-600' testId={testId}>
            <TriangleAlert size={14} />
        </ExplainedIcon>
    ) : (
        <ExplainedIcon message={reason.message} className='text-grey-70' testId={testId}>
            <Info size={14} />
        </ExplainedIcon>
    );

export default LockReasonIcon;
